import React from 'react';
import { Heading, Section } from './Primitives';
import { Logo } from './Logo';
export function BrandNote() {
  return <Section className="bg-cream" ariaLabel="About Pawsy Companion" data-id="element-19" data-mp="17hretgw7858y">
      <div className="mx-auto max-w-2xl rounded-2xl border border-orangey-100 bg-white px-6 py-8 text-center sm:px-9" data-id="element-20" data-mp="1chm63ljvywuj">
        <Logo className="mx-auto w-fit" data-id="element-21" data-mp="1hg76bkz51giz" />
        <Heading size="md" className="mt-5 !text-2xl sm:!text-[1.75rem]" data-id="element-22" data-mp="1hf5tbaykajym">
          One simple plan for your dog's everyday care.
        </Heading>
        <p className="mt-4 leading-relaxed text-ink-500" data-id="element-23" data-mp="orrvlan1hkdg">
          Pawsy brings feeding, hydration, treats, safe foods, routines and nutrition guidance together in one place.
        </p>
        <p className="mt-4 font-mono text-[0.68rem] font-semibold uppercase tracking-[0.14em] text-orangey-700" data-id="element-24" data-mp="yiw905x2gx66">
          Less guessing. More confidence. Better everyday care.
        </p>
      </div>
    </Section>;
}